
import { mapState } from 'vuex';
import LandingPageProduct from '@/components/crm/LandingPageProduct';

export default {
  name: 'LandingPageCartsSection',
  components: { LandingPageProduct },
  computed: {
    ...mapState('crmLandingPage', ['cartItems'])
  }
};
